import Icon from '@ant-design/icons';

import { ReactComponent as PodcastIcon } from './svgs/podcast.svg';

const Podcast = props => {
  return <Icon component={PodcastIcon} {...props} />;
};

export default Podcast;
